import React, {useState, useEffect} from "react";

export const HeaderSection = () => {
    return (
        <header className="relative min-h-fit bg-black ">

            {/* Background with Logo */}
            <div className="z-10 max-w-4xl mx-auto px-1 w-full">
                <div className="items-center mt-14">
                    {/* Left Column - Header Text */}
                        <img
                            src={require("../assets/fitm_helga_3.jpg")}
                            alt="Helga Logo"
                            className="w-full h-full object-contain"
                        />

                    <div className="text-center mt-14">

                        <p className="text-xl mb-8 text-white items-center">
                            We are happy to announce that <a href="https://www.fitmfest.com/" className="text-decoration: underline">Fire in the Mountains</a> festival is using the Helga Festival
                            App to provide
                            their visitors with the best festival app out there! Will your festival be next?
                        </p>
                    </div>
                </div>
            </div>

        </header>
    );
};
